import styled from 'styled-components';

const StatsBoxContainer = styled.div`
    color: white;
    padding: 50px;
    background-color: var(--transparent-color);
    @media (max-width: 767px) {
        flex-basis: 100%;
    }
    @media (min-width: 768px) {
        flex-basis: 50%;
    }
    @media (min-width: 992px) {
        flex-basis: 25%;
    }
    i {
        width: 40px;
        height: 40px;
        display: flex;
        background-color: black;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        margin: 0 auto 30px;
    }
    .number {
        font-size: 50px;
        font-weight: bold;
        margin: 0 0 20px;
    }
    p {
        font-size: 14px;
    }
`;
export default StatsBoxContainer;
